import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RenewalStatusForm from '../../../components/forms/RenewalStatusForm';
import { useRenewalStatusApi } from '../../../hooks/useRenewalStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { RenewalStatusDTO } from '../../../services/apiClient';

const RenewalStatusEdit: React.FC = () => {
  const { getById, edit, isLoading } = useRenewalStatusApi();
  const [entityData, setEntityData] = useState<RenewalStatusDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Renewal Statuses', href: '/admin/renewalstatuses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching RenewalStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/renewalstatuses');
    } catch (error) {
      console.error('Error updating RenewalStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/renewalstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.RenewalStatus.Edit"
    >
        {entityData ? (
          <RenewalStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/renewalstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default RenewalStatusEdit;
